import React, { createContext, useContext, useState, useEffect } from 'react';

const SchoolContext = createContext();

export const SchoolProvider = ({ children, schools }) => {
  const [selectedSchoolId, setSelectedSchoolId] = useState(() => {
    // Try to get from localStorage first
    const savedSchoolId = localStorage.getItem('selectedSchoolId');
    if (savedSchoolId && schools && schools.find(s => s.id === savedSchoolId)) {
      return savedSchoolId;
    }
    // If user has only one school, auto-select it
    if (schools && schools.length === 1) {
      return schools[0].id;
    }
    // If user has multiple schools, select the first one
    if (schools && schools.length > 0) {
      return schools[0].id;
    }
    return null;
  });

  const [selectedSchool, setSelectedSchool] = useState(null);

  useEffect(() => {
    if (schools && selectedSchoolId) {
      const school = schools.find(s => s.id === selectedSchoolId);
      setSelectedSchool(school);
      localStorage.setItem('selectedSchoolId', selectedSchoolId.toString());
    }
  }, [selectedSchoolId, schools]);

  const selectSchool = (schoolId) => {
    setSelectedSchoolId(schoolId);
    localStorage.setItem('selectedSchoolId', schoolId.toString());
  };

  return (
    <SchoolContext.Provider value={{
      schools: schools || [],
      selectedSchoolId,
      selectedSchool,
      selectSchool
    }}>
      {children}
    </SchoolContext.Provider>
  );
};

export const useSchool = () => {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchool must be used within a SchoolProvider');
  }
  return context;
};